import { render } from "./BlockquoteIcon.vue?vue&type=template&id=f568cd8c"
import script from "./BlockquoteIcon.vue?vue&type=script&lang=js"
export * from "./BlockquoteIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/.deploy/love-me.club/20260615-1539-vc2-2046-name-typo/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__